export default __webpack_public_path__ + "static/media/timer.09e0afd4.svg";